import { colors } from '@everlywell/leaves';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

export const textButtonStyles = css`
  color: ${colors.teal4};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.7px;
  text-decoration: none;
  cursor: pointer;

  &:visited {
    color: ${colors.teal4};
  }

  &:active {
    color: ${colors.teal4};
  }

  &:hover {
    color: ${colors.teal4};
    text-decoration: underline;
  }

  &:focus {
    color: ${colors.teal4};
  }
`;

export const LinkWrapper = styled.li`
  display: flex;
  flex-direction: row;
  ${props =>
    props.secondary &&
    css`
      span {
        color: ${colors.gray4};
      }
      a:hover {
        text-decoration: none;
      }
    `}
`;

export const SubHeaderLink = styled(Link)`
  ${textButtonStyles}
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  line-height: 24px;
`;

export const LinkText = styled.span`
  margin-left: 10px;
  font-weight: 600;
`;

export const SvgWrapper = styled.span`
  svg {
    path {
      fill: ${props => props.fill};
    }
  }
  &:hover {
    cursor: pointer;
    svg {
      path {
        fill: ${props => props.hoverColor};
      }
    }
  }
`;
